import { canValueInventory, gameConfig, type DotaMarketCatalogItem, type GameId, type ImportedSteamInventoryItem, type MarketplaceListing } from '@redd/contracts';

export const supportedGames: GameId[] = ['cs2', 'dota2', 'tf2'];
export const gameLabel = (game: GameId) => gameConfig[game].label;
export function gameFromHash(hash: string): GameId {
  const game = new URLSearchParams(hash.split('?')[1] ?? '').get('game');
  return game === 'dota2' || game === 'tf2' ? game : 'cs2';
}
export function gamePath(path: string, game: GameId) {
  return `${path}${path.includes('?') ? '&' : '?'}game=${game}`;
}
export function gameItemPath(name: string, game: GameId) {
  return gamePath(`/item/${encodeURIComponent(name)}`, game);
}
export function referenceCny(item: Pick<DotaMarketCatalogItem, 'referencePrice'>) {
  const quote = item.referencePrice;
  return quote?.currency === 'CNY' && Number.isFinite(quote.amount) && quote.amount > 0 ? quote.amount : undefined;
}
export function inventoryCny(item: ImportedSteamInventoryItem) {
  if (!canValueInventory(item)) return undefined;
  const price = item.referencePrice ? referenceCny(item) : item.priceCny;
  return price !== undefined && Number.isFinite(price) && price > 0 ? price : undefined;
}
export function canListGameItem(item: ImportedSteamInventoryItem, now = Date.now()) {
  if (item.game === 'tf2' && !/(?:\bkey\b|钥匙)/i.test(`${item.marketHashName} ${item.displayName} ${item.type}`)) return false;
  return item.inventoryVerified !== false && item.tradable && (item.game === 'dota2' || item.marketable)
    && (!item.tradableAfter || (Number.isFinite(Date.parse(item.tradableAfter)) && Date.parse(item.tradableAfter) <= now));
}
export function groupGameListings(listings: MarketplaceListing[], game: GameId) {
  const groups = new Map<string, DotaMarketCatalogItem>();
  for (const item of listings) {
    if (item.game !== game || item.status !== 'active') continue;
    const previous = groups.get(item.marketHashName);
    groups.set(item.marketHashName, {
      id: item.marketHashName, marketHashName: item.marketHashName, name: item.displayName,
      imageUrl: item.imageUrl, type: item.itemType || gameLabel(game),
      salePriceCny: Math.min(previous?.salePriceCny ?? Infinity, item.priceFen / 100),
      listings: (previous?.listings ?? 0) + 1,
    });
  }
  return [...groups.values()];
}
